import CryptoJS from "crypto-js";
import { toUrlSafeBase64 } from "./tools";

/**
 * 获取当前环境类型
 * @returns {string} 'production' | 'test' | 'local'
 */
const getCurrentEnv = () => {
  const hostname = window.location.hostname;

  // 判断是否为本地环境
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("192.168.")
  ) {
    return "local";
  }

  // 获取环境配置
  const config = {
    officialWebsiteDomain:
      process.env.VUE_APP_OFFICIAL_WEBSITE_DOMAIN || "www.skyshinetech.com",
    blockWatchDomain:
      process.env.VUE_APP_BLOCKWATCH_DOMAIN || "blockwatch.skyshinetech.com",
    testServer: process.env.VUE_APP_TEST_SERVER || "98.130.117.203",
  };

  // 判断是否为生产环境（官网域名或BlockWatch域名）
  if (
    hostname === config.officialWebsiteDomain ||
    hostname === config.blockWatchDomain
  ) {
    return "production";
  }

  // 判断是否为测试环境
  if (hostname === config.testServer) {
    return "test";
  }

  // 默认为生产环境
  return "production";
};

/**
 * 获取环境配置（带默认值）
 */
const getEnvConfig = () => {
  return {
    officialWebsiteDomain:
      process.env.VUE_APP_OFFICIAL_WEBSITE_DOMAIN || "www.skyshinetech.com",
    officialWebsitePort: process.env.VUE_APP_OFFICIAL_WEBSITE_PORT || "6555",
    blockWatchDomain:
      process.env.VUE_APP_BLOCKWATCH_DOMAIN || "blockwatch.skyshinetech.com",
    blockWatchPort: process.env.VUE_APP_BLOCKWATCH_PORT || "6789",
    testServer: process.env.VUE_APP_TEST_SERVER || "98.130.117.203",
    localOfficialPort: process.env.VUE_APP_LOCAL_OFFICIAL_PORT || "8080",
    localBlockWatchPort: process.env.VUE_APP_LOCAL_BLOCKWATCH_PORT || "8081",
  };
};

/**
 * 获取官网URL
 * @param {string} path - 路径
 * @returns {string} 完整的URL
 */
export const getOfficialWebsiteUrl = (path = "") => {
  const env = getCurrentEnv();
  const config = getEnvConfig();
  const protocol = env === "production" ? "https" : "http";

  if (env === "production") {
    return `${protocol}://${config.officialWebsiteDomain}${path}`;
  } else if (env === "test") {
    return `${protocol}://${config.testServer}:${config.officialWebsitePort}${path}`;
  } else {
    // 本地环境
    const hostname = window.location.hostname;
    return `${protocol}://${hostname}:${config.localOfficialPort}${path}`;
  }
};

/**
 * 获取BlockWatch URL
 * @param {string} path - 路径
 * @returns {string} 完整的URL
 */
export const getBlockWatchUrl = (path = "") => {
  const env = getCurrentEnv();
  const config = getEnvConfig();
  const protocol = env === "production" ? "https" : "http";

  if (env === "production") {
    return `${protocol}://${config.blockWatchDomain}${path}`;
  } else if (env === "test") {
    return `${protocol}://${config.testServer}:${config.blockWatchPort}${path}`;
  } else {
    // 本地环境
    const hostname = window.location.hostname;
    return `${protocol}://${hostname}:${config.localBlockWatchPort}${path}`;
  }
};

/**
 * 跳转到官网
 * @param {string} url - 目标路径
 */
export const goToOfficialWebsite = (url) => {
  window.location.href = getOfficialWebsiteUrl(url);
};

/**
 * 跳转到BlockWatch
 * @param {string} url - 目标路径
 */
export const goToBlockWatch = (url) => {
  const token = localStorage.getItem("token");
  const key = "ky@bky9y8l9b7t6";
  // token加密
  const encrypted = CryptoJS.AES.encrypt(token, key).toString();
  // 转换为URL安全格式
  const urlSafeToken = toUrlSafeBase64(encrypted);

  const fullUrl = getBlockWatchUrl(url);
  window.location.href = `${fullUrl}?skysp=${urlSafeToken}`;
};
